<div class="row">
  <div class="col-12">
    <app-label label="Miejscowość:">
      {{ application?.city || '-' }}
    </app-label>
  </div>
  @if (application?.roadNumber; as roadNumber) {
    <div class="col-md-4">
      <app-label label="Numer drogi:">
        {{ roadNumber }}
      </app-label>
    </div>
  }
  @if (application?.roadName; as roadName) {
    <div class="col-md-4">
      <app-label label="Nazwa drogi:">
        {{ roadName }}
      </app-label>
    </div>
  }
  @if (application?.street; as street) {
    <div class="col-md-4">
      <app-label label="Ulica:">
        {{ street }}
      </app-label>
    </div>
  }
</div>
<br>
<dl class="mb-5">
  <dt class="mb-3">
    <strong>Działki do których będzie prowadził zjazd przyległe do pasa drogowego</strong>
  </dt>
  <dd>
    <app-parcels-preview [parcels]="parcels || []"></app-parcels-preview>
  </dd>
</dl>
<p class="mb-2">
  <strong>Informacje o nieruchomości</strong>
</p>
<div class="row">
  <div class="col-12">
    <app-label label="Tytuł prawny do nieruchomości:">
      {{ application?.propertyLegalTitleDesc || application?.propertyLegalTitle?.name || '-' }}
    </app-label>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <app-label label='Obecny sposób wykorzystania nieruchomości:'>
      {{ application?.propertyUsagePurposeText || application?.propertyUsagePurpose || '-' }}
    </app-label>
  </div>
  <div class="col-md-6">
    @if (application?.propertyUsagePurpose) {
      <div class="row">
        <div class="col-12">
          <app-label label='Sposób wykorzystania nieruchomości po wybudowaniu zjazdu:'>
            {{ application?.postInvestmentUsage || '-' }}
          </app-label>
        </div>
        @if (application?.postInvestmentUsage?.includes('Ulegnie zmianie na inny cel')) {
          <div class="col-12">
            <app-label label='Zmiana wykorzystania nieruchomości:'>
              {{ application?.propertyUsageChange || '-' }}
            </app-label>
          </div>
        }
      </div>
    }
    @if (application?.decisionDate && application?.decisionNumber) {
      <div class="row">
        <div class="col-12">
          <app-label label='Nr decyzji/uzgodnienia:'>
            {{ application?.decisionNumber || '-' }}
          </app-label>
        </div>
        <div class="col-12">
          <app-label label='Data decyzji/uzgodnienia:'>
            {{ application?.decisionDate || '-' }}
          </app-label>
        </div>
      </div>
    }
  </div>
</div>
<div class="row">
  <br>
  @if (application?.referenceVehicleType; as referenceVehicleType) {
    <div class="col-12">
      <app-label label="Rodzaj pojazdu miarodajnego, który będzie obsługiwał zjazd:">{{ referenceVehicleType }}
      </app-label>
    </div>
  }
  @if (application?.propertyParkingSpacesCount; as propertyParkingSpacesCount) {
    <div class="col-12">
      <app-label
        label="Liczba stanowisk postojowych na terenie nieruchomości do której prowadził będzie zjazd:">{{ propertyParkingSpacesCount }}
      </app-label>
    </div>
  }
</div>
